import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class PriorInfoService {

  private _token:string = localStorage.getItem('token');
  
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  postPriorInfo$(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'priorinfo/add-prior-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getPriorInfo(info: any): Observable<any>{

    let headers = new Headers({ 'Authorization': this._token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint +'priorinfo/get-prior-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any


  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/prior-info.service.ts